<template>
  <div class="modal-overlay" @click.self="handleClose">
    <div class="modal-content">
      <div class="modal-header">
        <h2>发布需求</h2>
        <button class="btn-close" @click="handleClose">×</button>
      </div>

      <form class="post-form" @submit.prevent="handleSubmit">
        <div class="form-group">
          <label>需求标题：</label>
          <input
            type="text"
            v-model="form.title"
            placeholder="请输入需求标题"
            required
          />
        </div>

        <div class="form-group">
          <label>类型：</label>
          <select v-model="form.type" required>
            <option value="需求">需求</option>
            <option value="供应">供应</option>
          </select>
        </div>

        <div class="form-group">
          <label>行业：</label>
          <input
            type="text"
            v-model="form.hangye"
            placeholder="请输入行业，例如：低空服务"
            required
          />
        </div>

        <div class="form-group">
          <label>价格：</label>
          <input
            type="number"
            v-model="form.price"
            placeholder="请输入价格"
            required
          />
        </div>

        <div class="form-group">
          <label>内容描述：</label>
          <textarea
            v-model="form.content"
            placeholder="请输入详细描述"
            rows="4"
            required
          />
        </div>

        <div class="form-group">
          <label>发布人：</label>
          <input
            type="text"
            v-model="form.username"
            placeholder="请输入发布人名称"
            required
          />
        </div>

        <div class="form-group">
          <label>图片URL：</label>
          <input
            type="text"
            v-model="form.img"
            placeholder="请输入图片链接地址"
          />
        </div>

        <div class="form-actions">
          <button type="button" class="btn-cancel" @click="handleClose">取消</button>
          <button type="submit" class="btn-submit" :disabled="isSubmitting">
            {{ isSubmitting ? '发布中...' : '发布' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'PostDemandModal',
  data() {
    return {
      form: {
        title: '',
        type: '需求',
        hangye: '',
        price: '',
        content: '',
        username: '',
        img: ''
      },
      isSubmitting: false
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    async handleSubmit() {
      this.isSubmitting = true
      try {
        const payload = {
          id: 0,
          username: this.form.username,
          hangye: this.form.hangye,
          price: Number(this.form.price) || 0,
          type: this.form.type,
          title: this.form.title,
          img: this.form.img,
          content: this.form.content,
          createTime: new Date().toISOString()
        }

        const response = await axios.post('https://moodsci.com/Backend/lable/relaseDemand', payload, {
          headers: {
            'Content-Type': 'application/json'
          }
        })

        if (response.data) {
          this.$emit('submit', payload)
          this.resetForm()
          this.handleClose()
        }
      } catch (error) {
        console.error('发布需求失败:', error)
        alert('发布失败，请稍后重试')
      } finally {
        this.isSubmitting = false
      }
    },
    resetForm() {
      this.form = {
        title: '',
        type: '需求',
        hangye: '',
        price: '',
        content: '',
        username: '',
        img: ''
      }
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: #fff;
  border-radius: 16px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.modal-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}

.btn-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
  line-height: 1;
}

.btn-close:hover {
  color: #333;
}

.post-form {
  padding: 20px;
}

.form-group {
  margin-bottom: 16px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  box-sizing: border-box;
  transition: border-color 0.3s;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #42b983;
}

.form-group textarea {
  resize: vertical;
}

.form-actions {
  display: flex;
  gap: 12px;
  margin-top: 24px;
}

.btn-cancel,
.btn-submit {
  flex: 1;
  padding: 12px;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-cancel {
  background: #f5f5f5;
  border: 1px solid #ddd;
  color: #666;
}

.btn-cancel:hover {
  background: #eee;
}

.btn-submit {
  background: linear-gradient(135deg, #42b983 0%, #35495e 100%);
  border: none;
  color: #fff;
}

.btn-submit:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(66, 185, 131, 0.3);
}

@media (max-width: 768px) {
  .modal-content {
    width: 95%;
    max-height: 95vh;
  }

  .modal-header,
  .post-form {
    padding: 16px;
  }

  .form-actions {
    flex-direction: column;
  }

  .btn-cancel,
  .btn-submit {
    width: 100%;
  }
}
</style>
